import { http } from 'vue'

export default {
  async fetchContracts ({ commit }, status) {
    commit('SET_LOADING_STATUS', true)
    commit('SET_ERROR', null)
    try {
      let status = ''
      if (status) {
        status = `?status=${status}`
      }
      const response = await http.get('combo-extract' + status)
      commit('SET_CONTRACTS', response.data)
    } catch (error) {
      commit('SET_ERROR', 'Erro ao buscar a lista de contratos.')
    } finally {
      commit('SET_LOADING_STATUS', false)
    }
  },
  async fetchContractDetail ({ commit }, contractId) {
    commit('SET_LOADING_CONTRACT_DETAILS', true)
    commit('SET_ERROR', null)
    commit('SET_CURRENT_EXTRACT', [])
    try {
      const response = await http.get('combo-extract/' + contractId)
      commit('SET_CURRENT_EXTRACT', response.data)
    } catch (error) {
      commit('SET_ERROR', 'Erro ao buscar o detalhe do contrato.')
    } finally {
      commit('SET_LOADING_CONTRACT_DETAILS', false)
    }
  },
  clearCurrentExtract ({commit}) {
    commit('CLEAR_CURRENT_EXTRACT')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/combo_extract/actions.js